import * as React from "react";
const SvgFiRrLambda = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lambda_svg__a)">
      <path
        fill="#062147"
        d="M24 23a1 1 0 0 1-1 1h-1.028a4.97 4.97 0 0 1-4.472-2.764L11.391 9.017 3.888 23.46a1 1 0 0 1-1.776-.922l8.173-15.732-1.574-3.148A2.99 2.99 0 0 0 6.028 2H5a1 1 0 1 1 0-2h1.028A4.97 4.97 0 0 1 10.5 2.764l8.79 17.578A2.99 2.99 0 0 0 21.971 22H23a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lambda_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLambda;
